import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { readContact } from 'app/components/action-center/useTreatmentCaseBoard'
import { notifyError } from 'app/services/notify.client'
import type { ContactJson } from 'app/types/entities'
import { useHandleSearchParams } from 'app/utils'
import { bg } from 'lib/background'

export function useDrawerContact() {
  const [searchParams] = useSearchParams()
  const handleSearchParams = useHandleSearchParams()
  const drawerId = searchParams.get(`drawer`)
  const [contact, setContact] = useState<ContactJson>()
  useEffect(() => {
    if (!drawerId) {
      setContact(undefined)
      return
    }
    // `new` is the Contacts page's create drawer, which a records page has no form for.
    if (drawerId === `new`) {
      handleSearchParams({ drawer: undefined })
      return
    }
    if (contact?.id === drawerId) return
    let current = true
    bg(
      // network-only, as Contacts does, so a deep link never reads a stale cache entry
      // from another workspace.
      readContact(drawerId, { requestPolicy: `network-only` }).then((read) => {
        if (!current) return
        setContact(read)
        if (read) return
        notifyError(`Contact not found`)
        handleSearchParams({ drawer: undefined })
      }),
    )
    return () => {
      current = false
    }
  }, [drawerId])

  return {
    openDrawer: Boolean(contact),
    contact,
    onClose: () => {
      setContact(undefined)
      handleSearchParams({ drawer: undefined })
    },
    onChange: setContact,
  }
}
